import React, { Fragment } from 'react';
import Dropdown from 'src/ui/library/Dropdown';
import intl from 'react-intl-universal';
import Hidden from '@material-ui/core/Hidden';
import GetAppIcon from '@material-ui/icons/GetApp';
import Button from 'src/ui/library/Button';
import { formatFileSize } from 'src/helpers/upload';
import UploadPad from 'src/ui/library/Upload/UploadPad';
import { fileRejectErrorType } from 'src/helpers/upload';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { AlertDialog } from 'src/ui/library/Dialog';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

export const ServiceBatchPres = ({
  initType,
  onChangeInitType,
  attachFiles,
  progress,
  csvFiles,
  rejected,
  acceptedFileTypes,
  removeUnsupportedFile,
  submit,
  isDisabled,
  history,
  maxSize,
  toggleDelete,
  delUpload,
  enableDel,
  downloadTemplate,
  showSpinner,
  importStatus,
  importProgress,
  showErrors,
  errors,
  successCountwithRows,
  failureCountwithRows,
  closeErrorDialog,
}) => {
  let uploadProps = { acceptedFileTypes, maxSize };

  return (
    <div className={fnShowNewDashboard() ? 'ssi-batch-initiation new-ssi-batch' : 'ssi-batch-initiation'}>
      <section className="ssi-batch-section">
        <h3 className={'ssi-batch-header'}>{intl.get('serviceInit.batchInit.initTypeHeader')}</h3>
        <p>{intl.get('serviceInit.batchInit.subHeader')}</p>
        <Dropdown
          id="initType"
          name="initType"
          label={intl.get('serviceInit.batchInit.selectInitType')}
          className={'ssi-batch-initType-dropdown'}
          disableUnderline={true}
          disabled={showSpinner}
          required={true}
          onChange={event => onChangeInitType(event.target.value)}
          value={initType}
          options={[
            { value: 'individual', label: intl.get('serviceInit.addInit.types.individual') },
            { value: 'batch', label: intl.get('serviceInit.addInit.types.batch') },
          ]}
        />
      </section>
      {initType === 'batch' ? (
        !showSpinner ? (
          <section className="ssi-batch-section">
            <h3 className={'ssi-batch-header'}>{intl.get('serviceInit.batchInit.batchHeader')}</h3>
            <a className="ssi-download-template-link w-100 d-flex justify-content-start" onClick={downloadTemplate}>
              <GetAppIcon />
              <div className="ssi-download-template-text">{intl.get('serviceInit.batchInit.downloadTemplate')}</div>
            </a>
            <section className="content-section">
              <UploadPad dropHandler={attachFiles} multiple={false} {...uploadProps} />
              <div className="attach-container rejected">
                {rejected.map((file, i) => (
                  <div key={`${file.name}-${i}`} className="attach-file">
                    <span className="file-button-container">
                      <Button styleType="transparent-button" onClick={() => removeUnsupportedFile(file)}>
                        {intl.get('default.label.okay')}
                      </Button>
                    </span>
                    <span className={`mdi mdi-file file-icon`} />
                    {file.name}
                    <nav className="nav-bar">
                      <span className="file-error">{intl.get('fileUploadError.' + fileRejectErrorType(file))}</span>
                    </nav>
                  </div>
                ))}
              </div>
              <div className="attach-container">
                {csvFiles && csvFiles.length ? (
                  enableDel ? (
                    <a className="link" onClick={delUpload}>
                      {intl.get('serviceInit.batchInit.delete')}
                    </a>
                  ) : (
                    <span className="disabled-link">{intl.get('serviceInit.batchInit.delete')}</span>
                  )
                ) : null}
                {csvFiles &&
                  csvFiles.map((file, i) => (
                    <Fragment key={`${file.name}-${i}`}>
                      <div className="attach-file" aria-controls={`${file.name.replace(' ', '')}-${i}`}>
                        <input
                          type="checkbox"
                          className="delete-input"
                          aria-label="Select or unselect file deletion"
                          onClick={toggleDelete.bind(this, i)}
                        />
                        <span className={`mdi mdi-file file-icon`} />
                        {file.name}
                        <nav className="nav-bar">
                          <span className="file-size">{formatFileSize(file.size)}</span>
                        </nav>
                        <div className="upload-progress-bar" style={{ width: `${progress}%` }} />
                      </div>
                    </Fragment>
                  ))}
              </div>
            </section>
          </section>
        ) : (
          <div style={{ marginTop: '10%' }}>
            <Spinner size={70} />
            <div className="ssi-batch-import-status">
              <div>{'Import Status: ' + importStatus}</div>
              <div>{'Progress: ' + importProgress + '%'}</div>
            </div>
          </div>
        )
      ) : null}
      <div className="admin-actions">
        <div className="actions-button-wrapper">
          <Hidden xsDown>
            <Button
              styleType="secondary"
              className="action-button"
              disabled={showSpinner}
              onClick={e => {
                history.goBack();
              }}>
              {intl.get('serviceInit.batchInit.cancel')}
            </Button>
          </Hidden>
          <Button
            className="action-button"
            disabled={isDisabled || showSpinner}
            onClick={e => {
              submit();
            }}>
            {intl.get('serviceInit.batchInit.submit')}
          </Button>
        </div>

        {/* {initType === 'batch' ? (
          <a className="ssi-download-template-link" onClick={downloadTemplate}>
            <GetAppIcon />
            <div className="ssi-download-template-text">{intl.get('serviceInit.batchInit.downloadTemplate')}</div>
          </a>
        ) : null} */}
      </div>
      <AlertDialog
        open={showErrors}
        title={intl.get('serviceInit.batchInit.promptTitle')}
        cancelText={intl.get('serviceInit.batchInit.closeErrors')}
        onCancel={closeErrorDialog}>
        {intl.get('serviceInit.batchInit.success')}: {successCountwithRows}
        <br />
        {intl.get('serviceInit.batchInit.error')}: {failureCountwithRows}
        <br />
        <br />
        {errors && errors.length > 0 ? intl.get('serviceInit.batchInit.errorsPrompt') : null}
        <ul className="ssi-batch-init-errors-list">
          {errors.map(error => (
            <li>{error}</li>
          ))}
        </ul>
      </AlertDialog>
    </div>
  );
};

export default ServiceBatchPres;
